import { z } from 'zod/v3';
import { Parser } from '@cotera/era';

const ArtifactSchema = z.object({
  id: z.string(),
  status: z
    .enum(['ready', 'pending'])
    .or(z.object({ status: z.literal('failed'), message: z.string() })),
});

const ArtifactFullfillmentSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  numberOfRows: z.number().gte(0),
  enforcedLimit: z.number().nullable(),
  signature: z.record(z.string(), Parser.ExtendedAttributeTypeSchema),
  createdAt: z.date({ coerce: true }),
});

const ArtifactFailure = z.object({
  errorMessage: z.string(),
  createdAt: z.date({ coerce: true }),
});

const ArtifactRequestSchema = z.object({
  id: z.string(),
  sqlHash: z.string(),
  updatedAt: z.date({ coerce: true }),
  createdAt: z.date({ coerce: true }),
  requestedByUserId: z.string(),
  fullfillment: ArtifactFullfillmentSchema.nullable(),
  failure: ArtifactFailure.nullable(),
  invalidatedAt: z.date({ coerce: true }).nullable(),
  lastHeartBeatAt: z.date({ coerce: true }).nullable(),
});

export type Artifact = z.infer<typeof ArtifactSchema>;
export type ArtifactRequest = z.infer<typeof ArtifactRequestSchema>;
type ArtifactFullfillment = z.infer<typeof ArtifactFullfillmentSchema>;
type ArtifactFailure = z.infer<typeof ArtifactFailure>;

const useableCacheEntry = z.object({
  id: z.string(),
  createdAt: z.date({ coerce: true }),
  status: z.discriminatedUnion('t', [
    z.object({ t: z.literal('pending') }),
    z.object({
      t: z.literal('ready'),
      signature: z.record(z.string(), Parser.ExtendedAttributeTypeSchema),
      complete: z.boolean(),
    }),
  ]),
});

export type UseableCacheEntry = z.infer<typeof useableCacheEntry>;
